import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import {
  PermissionDto,
  PermissionTotalDto,
} from '@models/permissions/permission.dto';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private http: HttpClient) {}

  getPermissionList() {
    return this.http.get<PermissionDto[]>(
      environment.host + '/permissions/list',
    );
  }

  getRevokablePermissions() {
    return this.http.get<PermissionDto[]>(
      environment.host + '/permissions/revokable',
    );
  }

  getGroupedPermission() {
    return this.http.get<any[]>(environment.host + '/permissions/count');
  }

  getPermissionTotalList() {
    return this.http.get<PermissionTotalDto[]>(
      environment.host + '/permissions/totals/list',
    );
  }

  createPermission(permissions: PermissionDto[]) {
    return this.http.post(
      environment.host + '/permissions/create',
      permissions,
    );
  }

  createPermissionTotal(permissionTotal: PermissionTotalDto[]) {
    return this.http.post(
      environment.host + '/permissions/totals/create',
      permissionTotal,
    );
  }

  modifyPermission(permissions: PermissionDto[]) {
    return this.http.post(
      environment.host + '/permissions/modify',
      permissions,
    );
  }

  modifyPermissionTotal(permissionTotal: PermissionTotalDto[]) {
    return this.http.post(
      environment.host + '/permissions/totals/modify',
      permissionTotal,
    );
  }

  revokePermission(permissions: PermissionDto[]) {
    return this.http.post(
      environment.host + '/permissions/revoke',
      permissions,
    );
  }

  removePermission(permissions: PermissionDto[]) {
    return this.http.post(
      environment.host + '/permissions/remove',
      permissions,
    );
  }

  removePermissionTotal(permissionTotal: PermissionTotalDto[]) {
    return this.http.post(
      environment.host + '/permissions/totals/remove',
      permissionTotal,
    );
  }
}
